import script from "./Item.vue?vue&type=script&setup=true&lang=ts"
export * from "./Item.vue?vue&type=script&setup=true&lang=ts"

import "./Item.vue?vue&type=style&index=0&id=57fa70b0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57fa70b0"]])

export default __exports__